import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-epmall/order/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-epmall/order/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-epmall/order/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-epmall/order/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-epmall/order/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-epmall/order/submit',
    method: 'post',
    data: row
  })
}

export const toggleStatus = (ordeSn,nextStatus) => {
  return request({
    url: '/api/park-epmall/order/toggleorder/' + ordeSn,
    method: 'get',
    params: {'nextStatus':nextStatus}
  })
}
